// Chiavi di localStorage e profilo salvato nel browser.
//
// Modulo SENZA import (come su gestionale-gls): ci si appoggia anche
// core/api.jsx, e passare da core/auth creerebbe il ciclo
// api → auth → roleHelper → api.

export const TOKEN_KEY = "prToken";
export const USER_KEY = "prUtente";
export const LOGOUT_MSG_KEY = "prLogoutMessage";
export const ID_AZIENDA_KEY = "PayrollIdAzienda";
export const QUERY_CACHE_KEY = "pr-react-query-cache";

export function getUserInfo() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) return { nomeCompleto: "", email: "" };
    const u = JSON.parse(raw);
    return { nomeCompleto: u.nomeCompleto || "", email: u.email || "" };
  } catch {
    return { nomeCompleto: "", email: "" };
  }
}

export function saveUserInfo({ nomeCompleto, email }) {
  localStorage.setItem(USER_KEY, JSON.stringify({ nomeCompleto, email }));
}
